unable to read source [project]/node_modules/src/camera/factories.ts